/** "12m 41s", or null when the call has no usable duration. */
export function formatCallDuration(durationMs: number | null): string | null {
  if (durationMs == null || durationMs <= 0) return null;
  const totalSeconds = Math.round(durationMs / 1000);
  return `${Math.floor(totalSeconds / 60)}m ${String(totalSeconds % 60).padStart(2, "0")}s`;
}

/** "02:35" — a transcript offset, always mm:ss so the time gutter stays aligned. */
export function formatTranscriptOffset(startMs: number): string {
  const totalSeconds = Math.max(0, Math.floor(startMs / 1000));
  const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, "0");
  const seconds = String(totalSeconds % 60).padStart(2, "0");
  return `${minutes}:${seconds}`;
}
